import React from 'react'
import $ from 'jquery'
import {Popup} from 'semantic-ui-react'

const bestSellerBadge = (defaultAccount, cad) => {
  let {salesAccountBestSellers} = window
  let {best_seller_total} = cad

  if (defaultAccount.length > 0) {
    if (salesAccountBestSellers != undefined && salesAccountBestSellers.includes(cad.id)) {
      return content(defaultAccount, cad)
    }
  } else {
    if (best_seller_total != null && best_seller_total > 0) {
      return content(defaultAccount, cad)
    }
  }
}

const getBestSellerDate = (defaultAccount, cad) => {
  let defaultAccountStr = encodeURIComponent(defaultAccount.join(','))
  $.get(process.env.REACT_APP_API_URL + '/api/best_seller_data?cad_id=' + cad.id + '&default_account=' + defaultAccountStr, (result) => {
    let rows = result.data.split('<br/>')
    let row = rows[rows.length - 1]
    let date = row.split(' — ')[1]
    setTimeout(() => {
      $('#best-seller-on-' + cad.id).html(date)
    }, 100)
  })
}

const content = (defaultAccount, cad) => {
  return (
    <Popup position='top left' 
      trigger={
        <a className="ui left corner label" onMouseEnter={getBestSellerDate.bind(null, defaultAccount, cad)}><i aria-hidden="true" className="thumbs up outline icon"></i></a>
      }
    >
    <Popup.Content>
      This is a best seller on <span id={'best-seller-on-' + cad.id}></span>
    </Popup.Content>
  </Popup>
  )
}


export default bestSellerBadge
